import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import ResultsView from "@/components/ResultsView";

export default function SharedResults() {
  const { leadId } = useParams();
  const [searchParams] = useSearchParams();
  const refParam = searchParams.get("ref");
  const [state, setState] = useState({ loading: true, data: null, error: "" });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/results/${leadId}`);
        setState({ loading: false, data, error: "" });
      } catch (e) {
        setState({
          loading: false,
          data: null,
          error: e.response?.status === 404 ? "This link is no longer available." : "Could not load results.",
        });
      }
    })();
  }, [leadId]);

  const shareUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/api/r/${leadId}`
      : "";

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SiteHeader />
      <main className="flex-1 max-w-5xl w-full mx-auto px-5 sm:px-6 py-10 lg:py-16">
        {state.loading && (
          <div className="text-slate-500" data-testid="shared-loading">
            Loading your stack…
          </div>
        )}
        {state.error && (
          <div
            data-testid="shared-error"
            className="max-w-md mx-auto text-center text-slate-600 py-20"
          >
            <h1 className="font-display text-2xl font-semibold text-slate-900">{state.error}</h1>
            <p className="mt-2 text-sm text-slate-500">Try taking the quiz to generate a fresh recommendation.</p>
          </div>
        )}
        {state.data && (
          <ResultsView
            blurb={state.data.blurb}
            tools={state.data.tools}
            firstName={state.data.first_name}
            shareUrl={shareUrl}
            leadId={leadId}
            sourceRef={refParam}
            showRestart={true}
          />
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
